export default "__VITE_ASSET__Dv7JPH42__"